import { Link } from "react-router-dom";
import { MapPin, Clock, Heart } from "lucide-react";
import { useSeo } from "@/lib/useSeo";
import { Reveal, SectionHead } from "@/components/site/Reveal";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

const ROLES = [
  { title: "Senior Full-Stack Engineer", type: "Full-time", location: "Remote", tag: "Engineering" },
  { title: "Product Designer (UI/UX)", type: "Full-time", location: "Remote", tag: "Design" },
  { title: "Digital Marketing Specialist", type: "Full-time", location: "Remote", tag: "Growth" },
  { title: "AI/Automation Engineer", type: "Contract", location: "Remote", tag: "AI" },
];

export default function Careers() {
  useSeo({ title: "Careers", description: "Join Buddy Solution, a remote-first team building premium digital solutions worldwide." });
  return (
    <div className="bs-container py-16 lg:py-20">
      <Reveal><SectionHead center eyebrow="Careers" title="Build the future with us"
        subtitle="We're a remote-first team that values craft, integrity and growth. Open roles below are illustrative, reach out anytime." /></Reveal>

      <div className="mx-auto mt-14 max-w-3xl space-y-4">
        {ROLES.map((r, i) => (
          <Reveal key={r.title} delay={i * 0.05}>
            <div className="flex flex-col gap-4 bs-card p-6 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <div className="flex items-center gap-2"><Badge variant="secondary">{r.tag}</Badge></div>
                <h3 className="mt-2 font-display text-lg font-bold">{r.title}</h3>
                <div className="mt-2 flex flex-wrap gap-4 text-sm text-muted-foreground">
                  <span className="flex items-center gap-1.5"><MapPin className="h-4 w-4" /> {r.location}</span>
                  <span className="flex items-center gap-1.5"><Clock className="h-4 w-4" /> {r.type}</span>
                </div>
              </div>
              <Button asChild className="rounded-full" data-testid={`career-apply-${i}`}><Link to="/contact">Apply</Link></Button>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mx-auto mt-12 max-w-3xl rounded-3xl border border-border bg-card/40 p-8 text-center">
        <Heart className="mx-auto h-8 w-8 text-primary" />
        <h3 className="mt-3 font-display text-xl font-bold">Don't see your role?</h3>
        <p className="mx-auto mt-2 max-w-md text-muted-foreground">We're always keen to meet talented people. Send us a note and tell us what you'd love to work on.</p>
        <Button asChild className="mt-5 rounded-full"><Link to="/contact">Get in touch</Link></Button>
      </div>
    </div>
  );
}
